<template>
  <div id="data-view">
    <dv-full-screen-container :class="{xian:type>0}">

      <top-header v-if="type<1"/>

      <div class="main-content">
        <digital-flop :total="total" :list="list"/>

        <div class="block-left-right-content">
          <div class="block-top-left-content">
            <div class="left-top-content">

              <dv-scroll-board :config="monthDataConfig"/>
            </div>


          </div>
          <div style="position: relative" class="main-map">
            <dv-border-box-8 class="map_box">
              <fly :config="config" style="width:100%;height: 100%"/>
              <span
                class="bottom_text"
                style="">系统无故障运行{{ days }}天</span>
              <TimeBox></TimeBox>
            </dv-border-box-8>
            <BottomFlop :config="bottomData"></BottomFlop>
            <div style="" class="total_box">
              <p class="total_box_title">总订单：</p>
              <template v-for="item in countryTotal">
                <p class="total_box_item" :key="item.name"
                   v-if="item.name!=='临沂' && item.count">
                  <img style="" :src="item.icon.src" alt="">
                  <span style="">{{ item.count }}</span>
                </p>
              </template>
            </div>


          </div>
          <div class="block-top-bottom-content">
            <div class="block-top-content">
              <scroll-board :order="order"/>
            </div>


          </div>
        </div>
      </div>
    </dv-full-screen-container>

  </div>
</template>

<script>
import Fly from './fly.vue'
import topHeader from './topHeader'
import digitalFlop from './digitalFlop'
import rankingBoard from './bagBoard'

import scrollBoard from './scrollBoard'
import bgImg from '../../assets/map.jpg'
import ctImg from '../../assets/img.png'
import { colors, monthData, monthDataConfig, pointsList } from '@/components/data'
import {
  getBottomData,
  getCountConfig,
  getMonthDataConfig,
  getOrderConfig,
  getPackageConfig,
  getTotal
} from '@/components/util/methods'
import TimeBox from './time-box.vue'
import BottomFlop from '@/components/bottom-flop'

export default {
  name: 'DataView',
  components: {
    topHeader,
    digitalFlop,
    rankingBoard,
    Fly,
    scrollBoard,
    TimeBox, BottomFlop
  },
  data () {
    return {
      days: 0,
      flag: true,
      show: true,
      is_total: false,
      type: 0,
      colors: colors, monthDataConfig,bottomData:[],
      total: [],
      list: [],
      countryTotal: [],
      time: null,
      email: '',
      is_Show: true,
      baseUrl: 'https://app.hzds888.com',
      //baseUrl: 'http://test.c.cn',
      password: '',
      token: '',
      order: {
        header: ['时间', '订单编号', '金额', '用户'],
        data: [],
        columnWidth: [150, 165, 60, 160],
        align: ['center'],
        rowNum: 15,
        headerBGC: '#1981f6',
        headerHeight: 45,
        oddRowBGC: 'rgba(0, 44, 81, 0.8)',
        evenRowBGC: 'rgba(10, 29, 50, 0.8)'
      },
      packages: {
        header: ['时间', '国际物流单号', '国家', '用户'],
        data: [],
        columnWidth: [150, 165, 70, 150],
        align: ['center'],
        rowNum: 9,
        headerBGC: '#1981f6',
        headerHeight: 45,
        oddRowBGC: 'rgba(0, 44, 81, 0.8)',
        evenRowBGC: 'rgba(10, 29, 50, 0.8)'
      },
      is_xian: false,
      config: {
        points: pointsList,
        lines: [],
        icon: {
          show: true,
          src: ctImg
        },
        text: {
          show: true,
          fontSize: document.body.clientWidth > 2000 ? 18 : 12
        },
        k: -1,
        bgImgSrc: bgImg
      }
    }
  },
  methods: {
    login: function () {
      const token = localStorage.getItem('token')
      if (token && token !== 'null') {
        this.token = token
      }
      if (this.token) {
        this.getData()
        this.is_Show = false
        return
      }
      if (!this.email) {
        alert('请输入邮箱')
        return
      }
      if (!this.password) {
        alert('请输入邮箱')
        return
      }
      const data = {
        email: this.email,
        password: this.password
      }
      fetch(this.baseUrl + '/view/login', { // must match 'Content-Type' header
        cache: 'no-cache',
        headers: {
          'Domain': 'https://www.hzds888.com',
          'content-type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify(data),
        mode: 'cors',
        redirect: 'follow',
        referrer: 'no-referrer'
      }).then(res => res.json()).then(res => {
        // eslint-disable-next-line camelcase
        const { access_token: token } = res.data
        if (token) {
          localStorage.setItem('token', token)
          this.token = token
          this.getData()
          this.is_Show = false
        }
      })
    },
    getCountConfig (n) {
      return getCountConfig(n)
    },
    getRandomCountry (target) {
      pointsList.forEach(item => {
        const flag = Math.random() > 0.8
        if (flag && !target[item.name]) {
          if (item.name !== '临沂') {
            target[item.name] = 2
          }
        }
      })

    },
    getLines (orders = {}, packages = []) {
      const countryTotal = []
      const points = this.config.points
      const lines = []
      let target = []
      points.forEach(item => {
        countryTotal.push({
          count: orders[item.name] || 0,
          name: item.name,
          icon: item.icon
        })
        target.push(item.name)
      })
      countryTotal.sort((a, b) => b.count - a.count)
      this.countryTotal = countryTotal
      const list = {}
      packages.length && packages.forEach(item => {
        if (list[item.country]) {
          list[item.country]++
        } else {
          list[item.country] = 2
        }
      })
      //this.getRandomCountry(list)
      Object.keys(list).forEach(key => {
        if (target.indexOf(key) > -1) {
          let color = this.colors[this.getRandom(5)]

          lines.push({
            source: this.is_xian ? '西安' : '临沂',
            target: key,
            color,
            width: list[key] > 4 ? 4 : list[key],
            orbitColor: `${color}05`,
            duration: [50, 50],
            radius: key === '日本' ? 50 : 600
          })
        }
      })
      // this.$set(this.config, 'lines', lines)
      // this.show = false
      this.config = { ...this.config, lines }
      // this.show = true
      // this.$forceUpdate()
    },
    getRandom (m) {
      return Math.ceil(Math.random() * m)
    },
    getData () {
      const packages = [
        {
          'date': '2023-12-18 10:08:24',
          'shipped_number': 'YT23****21272111123',
          'country': '加拿大',
          'mail': 'lk**@outlook.com'
        },
        {
          'date': '2023-12-18 10:07:57',
          'shipped_number': 'YT23****21272110857',
          'country': '加拿大',
          'mail': 'cl**@163.com'
        },
        {
          'date': '2023-12-18 10:07:14',
          'shipped_number': 'YT23****21272110242',
          'country': '美国',
          'mail': '15**@qq.com'
        },
        {
          'date': '2023-12-18 10:01:45',
          'shipped_number': 'YT23****21272104388',
          'country': '英国',
          'mail': 'wa**@163.com'
        },
        {
          'date': '2023-12-18 09:54:27',
          'shipped_number': '3633****52270',
          'country': '日本',
          'mail': '11**@qq.com'
        },
        {
          'date': '2023-12-18 09:45:47',
          'shipped_number': 'YT23****21272087493',
          'country': '西班牙',
          'mail': 'ji**@qq.com'
        },
        {
          'date': '2023-12-18 09:44:30',
          'shipped_number': 'YT23****21272086404',
          'country': '墨西哥',
          'mail': 'mj**@163.com'
        },
        {
          'date': '2023-12-18 09:42:17',
          'shipped_number': 'JSEL****27984729YQ',
          'country': '美国',
          'mail': 'zh**@163.com'
        },
        {
          'date': '2023-12-18 09:41:53',
          'shipped_number': 'YT23****21272083915',
          'country': '西班牙',
          'mail': '19**@qq.com'
        },
        {
          'date': '2023-12-18 09:41:31',
          'shipped_number': 'YT23****21272083674',
          'country': '英国',
          'mail': 'wa**@qq.com'
        },
        {
          'date': '2023-12-18 09:38:21',
          'shipped_number': 'JSEL****58496738YQ',
          'country': '美国',
          'mail': 'zh**@163.com'
        },
        {
          'date': '2023-12-18 09:33:52',
          'shipped_number': 'UJ18****5240YP',
          'country': '西班牙',
          'mail': 'ti**@qq.com'
        },
        {
          'date': '2023-12-18 09:31:06',
          'shipped_number': 'UJ18****7475YP',
          'country': '巴西',
          'mail': 'ti**@qq.com'
        },
        {
          'date': '2023-12-18 09:29:38',
          'shipped_number': 'UJ18****1232YP',
          'country': '西班牙',
          'mail': 'ti**@qq.com'
        },
        {
          'date': '2023-12-18 09:24:42',
          'shipped_number': 'UJ18****7670YP',
          'country': '意大利',
          'mail': 'wu**@qq.com'
        },
        {
          'date': '2023-12-18 09:09:11',
          'shipped_number': 'JSEL****04328186YQ',
          'country': '美国',
          'mail': 'sa**@163.com'
        },
        {
          'date': '2023-12-18 09:09:01',
          'shipped_number': 'JSEL****98040496YQ',
          'country': '美国',
          'mail': 'sa**@163.com'
        },
        {
          'date': '2023-12-18 09:08:52',
          'shipped_number': 'JSEL****85495786YQ',
          'country': '美国',
          'mail': 'sa**@163.com'
        },
        {
          'date': '2023-12-18 09:08:43',
          'shipped_number': 'JSEL****79214907YQ',
          'country': '美国',
          'mail': 'sa**@163.com'
        },
        {
          'date': '2023-12-18 09:01:20',
          'shipped_number': 'YT23****21272048029',
          'country': '美国',
          'mail': 'wa**@163.com'
        },
        {
          'date': '2023-12-18 08:58:50',
          'shipped_number': 'YT23****21272046230',
          'country': '西班牙',
          'mail': 'ch**@qq.com'
        },
        {
          'date': '2023-12-18 08:53:22',
          'shipped_number': 'AM99****2019CN',
          'country': '美国',
          'mail': 'l1**@163.com'
        },
        {
          'date': '2023-12-18 08:53:17',
          'shipped_number': 'JSEL****51147299YQ',
          'country': '美国',
          'mail': 'xf**@163.com'
        },
        {
          'date': '2023-12-18 08:53:08',
          'shipped_number': 'JSEL****37069123YQ',
          'country': '美国',
          'mail': 'xf**@163.com'
        },
        {
          'date': '2023-12-18 08:52:59',
          'shipped_number': 'JSEL****95234687YQ',
          'country': '美国',
          'mail': 'xf**@163.com'
        },
        {
          'date': '2023-12-18 08:52:50',
          'shipped_number': 'JSEL****92794555YQ',
          'country': '美国',
          'mail': 'xf**@163.com'
        },
        {
          'date': '2023-12-18 08:51:45',
          'shipped_number': 'AM99****1968CN',
          'country': '美国',
          'mail': 'wa**@163.com'
        },
        {
          'date': '2023-12-18 08:49:56',
          'shipped_number': 'YT23****21272040602',
          'country': '美国',
          'mail': 'hs**@163.com'
        },
        {
          'date': '2023-12-18 08:48:17',
          'shipped_number': 'YT23****21272039584',
          'country': '美国',
          'mail': 'hs**@163.com'
        },
        {
          'date': '2023-12-18 08:47:34',
          'shipped_number': 'JSEL****42916308YQ',
          'country': '美国',
          'mail': 'sa**@163.com'
        },
        {
          'date': '2023-12-18 08:46:12',
          'shipped_number': 'YT23****21272038609',
          'country': '法国',
          'mail': 'ch**@qq.com'
        },
        {
          'date': '2023-12-18 08:45:14',
          'shipped_number': 'YT23****21272037965',
          'country': '墨西哥',
          'mail': '18**@163.com'
        },
        {
          'date': '2023-12-18 08:43:12',
          'shipped_number': 'JSEL****24990235YQ',
          'country': '美国',
          'mail': 'sh**@163.com'
        },
        {
          'date': '2023-12-18 08:42:21',
          'shipped_number': 'YT23****21272035873',
          'country': '意大利',
          'mail': 'wu**@qq.com'
        },
        {
          'date': '2023-12-18 08:41:36',
          'shipped_number': 'YT23****21272035523',
          'country': '美国',
          'mail': 'hs**@163.com'
        },
        {
          'date': '2023-12-18 08:40:40',
          'shipped_number': 'YT23****21272035096',
          'country': '美国',
          'mail': 'hs**@163.com'
        },
        {
          'date': '2023-12-18 08:39:56',
          'shipped_number': 'YT23****21272034497',
          'country': '美国',
          'mail': 'hs**@163.com'
        },
        {
          'date': '2023-12-18 08:39:30',
          'shipped_number': 'YT23****21272034231',
          'country': '西班牙',
          'mail': 'wu**@qq.com'
        },
        {
          'date': '2023-12-18 08:38:48',
          'shipped_number': 'YT23****21272033968',
          'country': '意大利',
          'mail': 'wu**@qq.com'
        },
        {
          'date': '2023-12-18 08:38:45',
          'shipped_number': 'YT23****21272033960',
          'country': '西班牙',
          'mail': 'ye**@qq.com'
        },
        {
          'date': '2023-12-18 08:38:25',
          'shipped_number': 'YT23****21272033872',
          'country': '意大利',
          'mail': 'wu**@qq.com'
        },
        {
          'date': '2023-12-18 08:37:31',
          'shipped_number': 'YT23****21272033494',
          'country': '意大利',
          'mail': 'wu**@qq.com'
        },
        {
          'date': '2023-12-18 08:34:35',
          'shipped_number': 'YT23****21272032515',
          'country': '美国',
          'mail': 'hs**@163.com'
        },
        {
          'date': '2023-12-18 08:26:22',
          'shipped_number': 'YT23****21272030555',
          'country': '西班牙',
          'mail': 'zh**@qq.com'
        },
        {
          'date': '2023-12-18 08:08:00',
          'shipped_number': 'UJ18****6688YP',
          'country': '加拿大',
          'mail': '15**@163.com'
        },
        {
          'date': '2023-12-18 10:11:34',
          'shipped_number': 'YT23****21236028813',
          'country': '美国',
          'mail': 'su**@163.com'
        },
        {
          'date': '2023-12-18 10:08:22',
          'shipped_number': 'AM99****2557CN',
          'country': '墨西哥',
          'mail': 's1**@163.com'
        },
        {
          'date': '2023-12-18 10:08:15',
          'shipped_number': 'YT23****21236028043',
          'country': '美国',
          'mail': 'wx**@163.com'
        },
        {
          'date': '2023-12-18 10:03:16',
          'shipped_number': 'YT23****21272106325',
          'country': '美国',
          'mail': 'ji**@163.com'
        },
        {
          'date': '2023-12-18 10:03:03',
          'shipped_number': 'AM99****1905CN',
          'country': '墨西哥',
          'mail': 's1**@163.com'
        },
        {
          'date': '2023-12-18 09:56:14',
          'shipped_number': 'AS83****0080CN',
          'country': '美国',
          'mail': 'yu**@163.com'
        },
        {
          'date': '2023-12-18 09:55:09',
          'shipped_number': 'YT23****21236025661',
          'country': '美国',
          'mail': 'zh**@163.com'
        },
        {
          'date': '2023-12-18 09:54:46',
          'shipped_number': 'YT23****21236025596',
          'country': '美国',
          'mail': 'zh**@163.com'
        },
        {
          'date': '2023-12-18 09:09:26',
          'shipped_number': 'AM99****4831CN',
          'country': '加拿大',
          'mail': '17**@qq.com'
        },
        {
          'date': '2023-12-18 10:10:34',
          'shipped_number': 'AT23****4136CN',
          'country': '美国',
          'mail': '99**@qq.com'
        },
        {
          'date': '2023-12-18 10:10:32',
          'shipped_number': 'AT23****4025CN',
          'country': '美国',
          'mail': '99**@qq.com'
        },
        {
          'date': '2023-12-18 10:00:32',
          'shipped_number': 'AT24****5257CN',
          'country': '美国',
          'mail': '99**@qq.com'
        },
        {
          'date': '2023-12-18 10:00:26',
          'shipped_number': 'AT24****5186CN',
          'country': '美国',
          'mail': '99**@qq.com'
        },
        {
          'date': '2023-12-18 09:58:03',
          'shipped_number': 'AT20****7510CN',
          'country': '美国',
          'mail': '99**@qq.com'
        },
        {
          'date': '2023-12-18 09:58:02',
          'shipped_number': 'AT20****7404CN',
          'country': '德国',
          'mail': '99**@qq.com'
        },
        {
          'date': '2023-12-18 09:58:01',
          'shipped_number': 'AT20****7302CN',
          'country': '美国',
          'mail': '99**@qq.com'
        },
        {
          'date': '2023-12-18 09:57:59',
          'shipped_number': 'AT20****7228CN',
          'country': '荷兰',
          'mail': '99**@qq.com'
        },
        {
          'date': '2023-12-18 09:57:58',
          'shipped_number': 'AT24****4849CN',
          'country': '美国',
          'mail': '99**@qq.com'
        },
        {
          'date': '2023-12-18 09:57:57',
          'shipped_number': 'AT24****4778CN',
          'country': '美国',
          'mail': '99**@qq.com'
        },
        {
          'date': '2023-12-18 09:57:56',
          'shipped_number': 'AT24****4716CN',
          'country': '美国',
          'mail': '99**@qq.com'
        },
        {
          'date': '2023-12-18 09:57:14',
          'shipped_number': 'AM99****1171CN',
          'country': '墨西哥',
          'mail': '77**@qq.com'
        },
        {
          'date': '2023-12-18 09:51:38',
          'shipped_number': 'AM99****0750CN',
          'country': '墨西哥',
          'mail': '17**@163.com'
        },
        {
          'date': '2023-12-18 09:44:18',
          'shipped_number': 'AM99****6636CN',
          'country': '墨西哥',
          'mail': '77**@qq.com'
        },
        {
          'date': '2023-12-18 09:09:40',
          'shipped_number': 'AM99****4862CN',
          'country': '墨西哥',
          'mail': 'nu**@163.cm'
        },
        {
          'date': '2023-12-18 09:08:39',
          'shipped_number': 'AT23****8421CN',
          'country': '美国',
          'mail': '55**@qq.com'
        },
        {
          'date': '2023-12-18 09:07:55',
          'shipped_number': 'UJ18****0447YP',
          'country': '英国',
          'mail': '13**@139.com'
        }
      ]
      fetch(this.baseUrl + '/api/platform/data-view', { // must match 'Content-Type' header
        cache: 'no-cache',
        headers: {
          'Domain': 'https://www.hzds888.com',
          'content-type': 'application/json',
        },
        method: 'POST',
        mode: 'cors',
        redirect: 'follow',
        referrer: 'no-referrer'
      }).then(res => res.json()).then(res => {
        // eslint-disable-next-line camelcase
        requestAnimationFrame(() => {
          const { total, country_orders, order,month_orders } = res.data
          this.total = getTotal(total, this.type > 2)
          this.getLines(country_orders, packages)
          this.order = getOrderConfig(order)
          this.monthDataConfig = getMonthDataConfig(month_orders)
          this.bottomData = getBottomData(total)
          this.list = order.map(item => item.amount).filter(item => item)
          this.packages = getPackageConfig(packages)
          this.flag = true
        })

      })




    },
    getQueryString (name) {
      let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i') // 正则语句
      let r = window.location.search.substr(1).match(reg) // 获取url的参数部分，用正则匹配
      if (r != null) {
        return decodeURIComponent(r[2]) // 解码得到的擦拭农户
      }
      return null
    },
    getDays () {
      const t = this.getQueryString('t')

      const today = t ? new Date(Number(t)).getTime() : new Date().getTime()
      const last = new Date('2020-10-1').getTime()

      this.days = Math.ceil((today - last) / 1000 / 3600 / 24)
    }
  },
  mounted () {
    const name = this.getQueryString('name')
    const type = this.getQueryString('type')
    this.is_xian = name && name.indexOf('陕') > -1
    this.is_total = type && type > 0 && type < 2
    this.type = type
    if (type > 0) {
      this.is_xian = true
      this.is_Show = false
      this.email = 'test@niubei.com'
      this.password = '11111111'
      this.login()
    }
    if (this.is_xian) {
      this.config.points[0].name = '西安'
      this.config.points[0].coordinate = [0.75, 0.42]
    }

    const token = localStorage.getItem('token')
    if (token && token !== 'null') {
      this.token = token
    }
    this.getData()
    this.getDays()
    const points = this.config.points
    points.forEach(item => {
      item.halo = { show: true, radius: 40 }
    })
    this.config = { ...this.config, points }
    this.time = setInterval(() => {
      this.getData()
      this.getDays()
    }, 3.1e5)
  },
  beforeDestroy () {
    clearInterval(this.time)
    this.time = null
  }
}
</script>

<style lang="less">
#data-view {
  width: 100%;
  height: 100%;
  background-color: #030409;
  color: #fff;


  .total_box {
    position: absolute;
    top: 10px;
    left: 10px;

    .total_box_title {
      font-size: 30px;
      color: #fff;
      font-weight: bold
    }

    .total_box_item {
      font-size: 18px;
      display: flex;
      align-items: center;
      margin: 10px 0;

      img {
        width: 55px;
        margin-right: 8px;
      }

      span {
        font-size: 25px;
        color: #fff;
        font-weight: bold;
      }
    }
  }

  #dv-full-screen-container {
    background-image: url('./img/bg.png');
    background-size: 100% 100%;
    box-shadow: 0 0 3px blue;
    display: flex;
    flex-direction: column;

    &.xian {
      background-image: url("./bg.png");
    }
  }

  .main-content {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .block-left-right-content {
    flex: 1;
    display: flex;
    margin-top: 20px;
  }

  .block-top-bottom-content {
    width: 20%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-left: 20px;
  }

  .block-top-content {
    height: 100%;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    padding-bottom: 20px;
  }

  .bottom_text {
    position: absolute;
    font-size: 60px;
    bottom: 5px;
    left: 80px;
    color: white
  }

  input {
    -webkit-appearance: none;
    width: 400px;
    height: 50px;
    border-radius: 4px;
    margin: 10px;
    box-sizing: border-box;
    border: 1px solid #ccc;
    outline: none;
    font-size: 28px;
    padding: 0 15px;
  }

  button {
    -webkit-appearance: none;
    box-sizing: border-box;
    width: 400px;
    height: 50px;
    border: 1px solid #ccc;
    outline: none;
    background: #222;
    color: #fff;
    margin: 10px;
    border-radius: 4px;
    font-size: 35px;
  }

  .main-map {
    width: 80%;
  }

  .block-top-left-content {
    width: 12%;

    padding-left: 10px;
    padding-bottom: 20px;

    .left-top-content {
      height: 100%;
      width: 100%;

    }
  }

  .map_box {
    padding: 3px;
    height: 85%;
    position: relative;
  }
}

@media screen and (max-width: 2000px) {
  #data-view {
    .bottom_text {

      font-size: 30px;
      bottom: 5px;
      left: 40px;

    }

    .main-content {
      height: 80%;
    }

    .total_box {


      .total_box_title {
        font-size: 20px;
        color: #fff;
        font-weight: bold
      }

      .total_box_item {
        font-size: 10px;
        display: flex;
        align-items: center;
        margin: 10px 0;

        img {
          width: 22px;
          margin-right: 4px;
        }

        span {
          font-size: 18px;
          color: #fff;
          font-weight: bold;
        }
      }
    }

    #dv-full-screen-container {

      box-shadow: 0 0 2px blue;

    }


    .block-left-right-content {

      margin-top: 10px;
    }

    .block-top-left-content {
      width: 12%;

      padding-left: 10px;
      padding-bottom: 20px;

      .left-top-content {
        height: 100%;
        width: 100%;

      }
    }

    .block-top-bottom-content {
      width: 28%;

      padding-left: 10px;
      padding-bottom: 20px;
    }

    .block-top-content {
      height: 100%;

      padding-bottom: 10px;
    }


    .main-map {
      width: 60%;
    }

    .map_box {
      padding: 3px;
      height: 83%;
      position: relative;
    }
  }
}

@media screen and (max-width: 1700px) {
  #data-view {
    .bottom_text {

      font-size: 25px;
      bottom: 5px;
      left: 32px;

    }

    .main-content {
      height: 80%;
    }

    .block-top-left-content {
      width: 12%;

      padding-left: 10px;
      padding-bottom: 20px;

      .left-top-content {
        height: 100%;
        width: 100%;

      }
    }

    .total_box {


      .total_box_title {
        font-size: 17px;
        color: #fff;
        font-weight: bold
      }

      .total_box_item {
        font-size: 9px;
        display: flex;
        align-items: center;
        margin: 12px 0;

        img {
          width: 22px;
          margin-right: 4px;
        }

        span {
          font-size: 17px;
          color: #fff;
          font-weight: bold;
        }
      }
    }

    #dv-full-screen-container {

      box-shadow: 0 0 2px blue;

    }


    .block-left-right-content {

      margin-top: 9px;
    }

    .block-top-bottom-content {
      width: 29%;

      padding-left: 8px;
      padding-bottom: 17px;
    }

    .block-top-content {
      height: 100%;

      padding-bottom: 8px;
    }


    .main-map {
      width: 71%;
    }

    .map_box {
      padding: 2px;
      height: 80%;
      position: relative;
    }
  }
}

</style>
<style lang="less" scoped>
.left-top-content {
  width: 100%;
  box-sizing: border-box;
  margin-left: 0;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  height: 100%;
  overflow: hidden;
  font-size: 40px;


  .title {
    position: relative;
    font-size: 40px;
    line-height: 120px;
    width: 80px;
    padding: 0 50px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}

@media screen and (max-width: 2000px) {
  .left-top-content {

    font-size: 17px;


    .title {

      font-size: 17px;
      line-height: 51px;
      width: 34px;
      padding: 0 20px;
    }
  }
}
</style>
<style>
.left-top-content .row-item {
  font-size: 18px !important;
}

.left-top-content .header-item {
  font-size: 18px !important;
}

@media screen and (max-width: 2000px) {
  .left-top-content .row-item {
    font-size: 12px !important;
  }

  .left-top-content .header-item {
    font-size: 14px !important;
  }
}
</style>
